/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useEffect, useState } from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { WORKBOARD_CURRENT_VALUATIONS_URL } from 'dashboard409a/common/config/urls';
import { getPreviousWorkboardRoute } from 'dashboard409a/utilities/navigation';
import {
  AppAutoSelect,
  clearAppAutoSelect,
  DASHBOARD_409A,
  getAppAutoSelect,
  PORTFOLIO_VALUATION,
} from 'utilities/appSwitch';
import OrganizationSelector from '../OrganizationSelector';
import useStyles from './styles';
import { IProductSelector } from './types';

type ProductSelection = 'NONE' | AppAutoSelect;

const ProductSelector: FC<IProductSelector> = props => {
  const { permissions } = props;
  const navigate = useNavigate();
  const [appSelected, setAppSelected] = useState<ProductSelection>('NONE');
  const [{ user }] = useStore() as unknown as UseStoreValues;

  const classes = useStyles();

  const continueToPortfolioValuation = useCallback(() => setAppSelected(PORTFOLIO_VALUATION), []);
  const continueToDashboard409A = useCallback(() => {
    const savedWorkboardRoute = getPreviousWorkboardRoute();
    navigate(savedWorkboardRoute || WORKBOARD_CURRENT_VALUATIONS_URL);
  }, [user, navigate]);

  useEffect(() => {
    const autoSelect = getAppAutoSelect();
    if (autoSelect) {
      clearAppAutoSelect();
      if (autoSelect === PORTFOLIO_VALUATION) {
        continueToPortfolioValuation();
      } else if (autoSelect === DASHBOARD_409A) {
        continueToDashboard409A();
      }
    }
  }, []);

  switch (appSelected) {
    case PORTFOLIO_VALUATION:
      return <OrganizationSelector lowerPermissions={permissions} />;

    case DASHBOARD_409A:
      return <OrganizationSelector lowerPermissions={permissions} isDashboard />;

    default:
      break;
  }

  return (
    <Paper className={classes.root}>
      <Typography variant="h2" className={classes.title}>
        Select Product
      </Typography>

      <>
        <Button variant="contained" fullWidth className={classes.button} onClick={continueToPortfolioValuation}>
          <p className={classes.buttonText}>Continue to Portfolio Valuation</p>
        </Button>

        <Typography component="p" variant="h3" className={classes.orText}>
          OR
        </Typography>

        <Button variant="contained" fullWidth className={classes.button} onClick={continueToDashboard409A}>
          <p className={classes.buttonText}>Continue to Workboard</p>
        </Button>
      </>
    </Paper>
  );
};

export default ProductSelector;
